import React from 'react';
import { connect } from 'react-redux';
import { getValues } from '../../virtuoso/helper'

export const makeJSONLD = (catalog, card, lang) => {
  const data = {"@context": ["https://schema.org"]};
  data["id"] = card.iri;
  data["@type"] = "Dataset";
  data["name"] = getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, card.values);
  data["description"] = getValues("http://purl.org/dc/terms/description", lang, card.values);
  const url =  window.location.protocol+'//'+window.location.host+window.location.pathname+"#/adms/"+card.iri;
  data["url"] = url;
  data["license"] = getValues("http://purl.org/dc/terms/license", lang, card.values);
  data["identifier"] = card.iri;
  //creator
  const creators = card.values.filter(value => value.predicat.value == "http://purl.org/dc/terms/creator");
  // , lang, card.values);
  //console.log("!!!!", creators);
  if (Array.isArray(creators) && creators.length>0){
    data["creator"] = [];
    creators.forEach(item => {
      const creator = {};
      if (Array.isArray(item.types)){
        if (item.types.includes("http://xmlns.com/foaf/0.1/Agent"))
          creator["@type"] = "Agent";
        if (item.types.includes("http://xmlns.com/foaf/0.1/Person"))
          creator["@type"] = "Person";
        if (item.types.includes("http://xmlns.com/foaf/0.1/Organization"))
          creator["@type"] = "Organization"
        if (item.types.includes("http://data.europa.eu/m8g/PublicOrganisation"))
          creator["@type"] = "Organization"      
      };
      //Проверка расширенных результатов на Agent - делает предупреждение
      //creator["@type"] = "Person";
      if (item.labels){
        const label = getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, item.labels.values);
        const title = getValues("http://purl.org/dc/terms/title", lang, item.labels.values);
        creator["name"] = (label && !label.startsWith("http")) ? label: title;
      };
      data["creator"].push(creator);
    });
  };
  //publisher
  const publishers = card.values.filter(value => value.predicat.value == "http://purl.org/dc/terms/publisher");
  if (Array.isArray(publishers) && publishers.length>0){
    data["publisher"] = [];
    publishers.forEach(item => {
      //console.log("JSONLDScript.js", item); //http://xmlns.com/foaf/0.1/homepage
      const publisher = {};
      if (Array.isArray(item.types)){
        if (item.types.includes("http://xmlns.com/foaf/0.1/Agent"))
          publisher["@type"] = "Agent";
        if (item.types.includes("http://xmlns.com/foaf/0.1/Person"))
          publisher["@type"] = "Person";
        if (item.types.includes("http://xmlns.com/foaf/0.1/Organization"))
          publisher["@type"] = "Organization"
        if (item.types.includes("http://data.europa.eu/m8g/PublicOrganisation"))
          publisher["@type"] = "Organization"      
      };
      //Проверка расширенных результатов на Agent - делает предупреждение
      //creator["@type"] = "Person";
      if (item.labels){
        const label = getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, item.labels.values);
        const title = getValues("http://purl.org/dc/terms/title", lang, item.labels.values);
        publisher["name"] = (label && !label.startsWith("http")) ? label: title;
      };
      data["publisher"].push(publisher);
    });
  };

  //includedInDataCatalog
  data["includedInDataCatalog"] = {
    "@id": catalog.iri,
		"@type": "DataCatalog",
		"url": window.location.protocol+'//'+window.location.host+window.location.pathname,
  };
  if (Array.isArray(catalog.values))
    data["includedInDataCatalog"]["name"]= getValues("http://www.w3.org/2000/01/rdf-schema#label", lang, catalog.values);
  if (lang)
    data["includedInDataCatalog"]["spatialCoverage"] = lang ;
  else
    data["includedInDataCatalog"]["spatialCoverage"] = "RU" ;
  //distribution
  if (Array.isArray(card.distributions) && card.distributions.length > 0){
    data["distribution"] = [];
    card.distributions.forEach(item => {
      if (Array.isArray(item.values)){
        const distribution = {
          "@id": item.iri,
          "@type": "DataDownload",
          "encodingFormat": "RDF",
          "description": getValues("http://purl.org/dc/terms/description", lang, item.values),
          "license": getValues("http://purl.org/dc/terms/license", lang, card.values),
          "contentUrl": getValues("http://www.w3.org/ns/dcat#downloadURL", lang, item.values)
        };
        data["distribution"].push(distribution);
      }
    });
  }
//keywords
  const keywords = card.values.filter(
    value => value.predicat.value === "http://www.w3.org/ns/dcat#keyword"
  );

  if (Array.isArray(keywords) && keywords.length > 0) {
    data["keywords"] = keywords
      .map(item => {
        if (item.object && item.object.value)
          return item.object.value;

        if (item.value)
          return item.value;

        return null;
      })
      .filter(value => value);
  }

  //temporalCoverage
  const temporalCoverage = getValues(
    "http://purl.org/dc/terms/temporal",
    lang,
    card.values
  );

  if (temporalCoverage) {
    data["temporalCoverage"] = temporalCoverage;
  }

  //spatialCoverage
  const spatialCoverage = getValues(
    "http://purl.org/dc/terms/spatial",
    lang,
    card.values
  );

  if (spatialCoverage) {
    data["spatialCoverage"] = spatialCoverage;
  }

  //variableMeasured
  const variableMeasured = getValues(
    "http://schema.org/variableMeasured",
    lang,
    card.values
  );

  if (variableMeasured) {
    data["variableMeasured"] = variableMeasured;
  }
  
  return JSON.stringify(data);
}

class JSONLDScriptComponent extends React.Component {
  render(){
    //console.log(this, makeJSONLD(this.props.catalog, this.props.card, this.props.lang)); 
    return (
      <script type="application/ld+json">
        {makeJSONLD(this.props.catalog, this.props.card, this.props.lang)}
      </script>
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux
  const {vadms, vasset, vset } = state;
  const {lang, triplet} = props;
  return {
    lang: (lang)?lang: vset.lang,
    catalog: { state: vadms.state, ...vadms.catalog},
    card: vasset
  };
}
export const JSONLDScript = connect(mapStateToProps)(JSONLDScriptComponent);